export const PageType = {
  Home: 'home',
  Static: 'static',
  CatalogRoot: 'catalog_root',
  CatalogProductList: 'catalog_product_list',
  CatalogProduct: 'catalog_product',
  Certificates: 'certificates',
  Cart: 'cart',
  Order: 'order',
  SuccessOrder: 'success_order',
  NewsList: 'news_list',
  NewsDetail: 'news',
  ArticlesList: 'article_list',
  ArticleDetail: 'article',
  VideoReviewList: 'video_review_list',
  NotFound: 'not_found',
  LoginPage: 'login',
  Favourite: 'favourite',
  Contacts: 'contacts',
  FunctionalTesting: 'func_testing_form',
  ShoeTesting: 'shoe_fitting_form',
  Brands: 'brands',
  BrandProductList: 'brand_product_list',

  ProfileRoot: 'profile_root',
  Profile: 'profile',
  ProfileFavourite: 'profile_favourite',
  ProfileOrderList: 'order_list',
  ProfileBonusAccount: 'bonus_account',
  ProfileReservations: 'profile_reservations',
  ProfileServiceRecords: 'bookings',

  CatalogSales: 'catalog_sale',
  BugReport: 'bug_report',
} as const
